/* eslint-disable no-underscore-dangle */
import { listenToSubmit, updateFormUrl, updateStarsBar } from "components/stars-bar/stars-bar"
import { PHOTO_RATING, PHOTO_RATING_BAR, PHOTO_RATING_NUM } from "../constants"

/** @typedef {import('../models/photo-entity').default} PhotoEntity */

export default class StarsElement {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @memberof StarsElement
   */
  static fromHtmlElement(htmlElement) {
    return new StarsElement(
      htmlElement.querySelector(PHOTO_RATING),
      htmlElement.querySelector(PHOTO_RATING_BAR),
      htmlElement.querySelector(PHOTO_RATING_NUM),
    )
  }

  /**
   * Creates an instance of StarsElement.
   * @param {HTMLElement} root
   * @param {HTMLElement} starsBarElement
   * @param {HTMLElement} starsNumElement
   * @memberof StarsElement
   */
  constructor(root, starsBarElement, starsNumElement) {
    this.root = root
    this.starsBarElement = starsBarElement
    this.starsNumElement = starsNumElement

    this._onSubmitCallbackList = []
    listenToSubmit(this.starsBarElement, (ratingOrNull) => {
      this._onSubmitCallbackList.forEach((cb) => cb(ratingOrNull))
    })
  }

  /**
   * @param {function(string?) : void} callback
   * @memberof StarsElement
   */
  onSubmit(callback) {
    this._onSubmitCallbackList.push(callback)
  }

  /**
   * @param {PhotoEntity} photo
   * @memberof StarsElement
   */
  apply(photo) {
    this.root.classList.toggle("is-hidden", photo.stars === null)

    if (photo.stars !== null) {
      this.starsNumElement.textContent = photo.stars.toFixed(1)
      updateStarsBar(this.starsBarElement, {
        activeStars: Math.round(photo.stars),
      })
      updateFormUrl(this.starsBarElement, {
        url: `/photos/${photo.id}/photo_votes`,
      })
    }
  }
}
